var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('p',[_vm._v(" "+_vm._s(_vm.mainText)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.subText)+" ")]),_c('div',{staticClass:"loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }